<div *transloco="let t" class="p-6">
	<div class="flex flex-row items-start justify-start">
		<div class="w-[50%]">
			@if (versions.length > 0) {
				<mat-list>
					{{ t('billing.versions') }}
					@for (version of versions; track $any(version).exportId) {
						<mat-list-item>{{ t('billing.version') }}: {{ $any(version).exportId }}</mat-list-item>
					}
				</mat-list>
			}
		</div>
	</div>
	<ng-container>
		<div class="periods-section w-full">
			<div class="section-header flex items-end justify-between gap-2">
				<div class="flex items-center gap-2">
					<mat-icon fontSet="material-symbols-outlined" class="text-primary">euro_symbol</mat-icon>
					<h3 class="text-lg font-medium m-0">
						{{ t('billing.costGroupsTitle') }} {{ t('common.for') }}
						{{ dateUtil.setDateFormatByActiveLang(periodFc.value?.validFrom, '', false, true) }}
						{{ t('common.until') }}
						{{ dateUtil.setDateFormatByActiveLang(periodFc.value?.validTo, '', false, true) }}
					</h3>
					<ara-popover class="inline-flex align-middle" [content]="tooltipContent">
						<mat-icon class="inline-block align-middle info-icon" [svgIcon]="icons.get('infoOutline')"></mat-icon>
					</ara-popover>
				</div>
				<mat-form-field appearance="outline" class="w-80 -mb-6">
					<mat-label>{{ t('billing.period') }}</mat-label>
					<mat-select (selectionChange)="loadPeriod($event)" [formControl]="periodFc">
						<mat-select-trigger>
							<!-- custom trigger, if not item will not be displayed -->
							@if (periodFc.value) {
								<div class="flex items-center">
									<mat-icon fontSet="material-symbols-outlined" class="mr-2 text-gray-500">
										{{ periodFc.value.locked ? 'lock' : 'lock_open_right' }}
									</mat-icon>
									{{ dateUtil.setDateFormatByActiveLang(periodFc.value.validFrom, '', false, true) }}
									- {{ dateUtil.setDateFormatByActiveLang(periodFc.value.validTo, '', false, true) }}
								</div>
							}
						</mat-select-trigger>
						@for (period of periods(); track period.exportId) {
							<mat-option [value]="period">
								<div class="flex items-center">
									<mat-icon fontSet="material-symbols-outlined" class="mr-2 text-gray-500">
										{{ period.locked ? 'lock' : 'lock_open_right' }}
									</mat-icon>
									{{ dateUtil.setDateFormatByActiveLang(period.validFrom, '', false, true) }}
									- {{ dateUtil.setDateFormatByActiveLang(period.validTo, '', false, true) }}
								</div>
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		</div>

		@if (!finishedLoading()) {
			<div class="spinner-style w-[90%] h-[75%]">
				<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
			</div>
		} @else if (!periodFc.value) {
			<div class="flex flex-row justify-center items-center h-[35rem]">
				<mat-icon class="mr-2">info_outline</mat-icon>
				{{ t('billing.selectPeriodFirst') }}
			</div>
		} @else if (!costGroupTypes().length) {
			<div class="flex flex-row justify-center items-center h-[35rem]">
				<mat-icon>ads_click</mat-icon>
				{{ t('common.noData') }}
			</div>
		} @else {
			<mat-tab-group
				[mat-stretch-tabs]="false"
				preserveContent
				class="p-2"
				[selectedIndex]="selectedTabIndex()"
				(selectedIndexChange)="selectedTabIndex.set($event)">
				@for (costGroupType of costGroupTypes(); track costGroupType.exportId) {
					<mat-tab [disabled]="!!(flatrateExemptionService.showDetail$ | async)">
						<ng-template mat-tab-label>
							<div class="flex flex-row items-center gap-2 py-1">
								<!-- Linker Teil: Infos -->
								<div class="flex flex-col text-left min-w-0 max-w-[12rem]">
									<!-- Zeile 1: Kategorie -->
									<span class="font-medium pb-1">
										{{ t('enum.' + costGroupType.category) }}
									</span>

									<span class="text-[11px] text-gray-500 truncate">
										@if (costGroupType.name?.trim()) {
											{{ costGroupType.name }}
										}
									</span>
								</div>

								<span class="ml-2 font-medium text-xs text-primary">({{ countFor(costGroupType) }})</span>
							</div>
						</ng-template>
						@if (!(flatrateExemptionService.showDetail$ | async)) {
							@if (countFor(costGroupType)) {
								<div class="flex flex-row justify-end items-center pt-2 gap-2">
									<!-- Expand/Collapse Buttons -->
									<div class="flex items-center">
										<button (click)="collapseAllCostGroups()" mat-icon-button>
											<mat-icon [matTooltip]="t('commonActions.collapseAll')" [svgIcon]="icons.get('arrowCollapse')"></mat-icon>
										</button>
										<button (click)="expandAllCostGroups()" mat-icon-button>
											<mat-icon [matTooltip]="t('commonActions.expandAll')" [svgIcon]="icons.get('arrowExpand')"></mat-icon>
										</button>
									</div>
									<!-- View Toggle -->
									@if (
										costGroupType.category === 'HEAT_ENERGY' ||
										costGroupType.category === 'HEATING_OPERATION' ||
										costGroupType.category === 'ANCILLARY_SERVICES'
									) {
										<div
											class="flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-200 h-10"
											(click)="$event.stopPropagation()">
											<mat-icon class="text-gray-500 !text-[20px]">table_rows</mat-icon>
											<mat-slide-toggle
												[checked]="invoiceViewMode() === 'card'"
												(change)="$event.checked ? invoiceViewMode.set('card') : invoiceViewMode.set('table')"
												color="primary"></mat-slide-toggle>
											<mat-icon class="text-gray-500 !text-[20px]">grid_view</mat-icon>
										</div>
									}
									@if (periodFc.value && !selectedPeriodService.selectedPeriod().locked) {
										<button class="m-2" [matMenuTriggerFor]="reorderCostMenu" #menuTrigger="matMenuTrigger" mat-raised-button>
											<mat-icon>format_list_numbered_rtl</mat-icon>
											<div class="ml-2">
												{{ t('billing.reOrderCosts') }}
											</div>
										</button>
										<button (click)="addCostGroup(costGroupType)" class="m-2" color="primary" mat-raised-button>
											<mat-icon>add</mat-icon>
											<div class="ml-2">
												{{ t('billing.addCostGroup') }}
											</div>
										</button>
										<mat-menu #reorderCostMenu="matMenu" class="premium-menu">
											<div cdkDropList (cdkDropListDropped)="drop($event, costGroupType, menuTrigger)">
												@for (costGroup of matchingCostGroups.get(costGroupType); track costGroup.exportId) {
													<div class="flex flex-row items-center p-2 w-full cursor-move" cdkDrag>
														<div class="w-10 flex-shrink-0 text-right pr-2">{{ costGroup.order }}:</div>
														<div class="flex-1 truncate">
															{{ costGroup.name }}
														</div>
													</div>
												}
											</div>
										</mat-menu>
									}
								</div>
							}
						}
						@if (!countFor(costGroupType)) {
							<div class="flex flex-col justify-center items-center h-[20rem] text-gray-500">
								<div class="flex items-center mb-4">
									<mat-icon class="mr-2">info_outline</mat-icon>
									{{ t('common.noData') }}
								</div>
								@if (periodFc.value && !selectedPeriodService.selectedPeriod().locked) {
									<button (click)="addCostGroup(costGroupType)" color="primary" mat-raised-button>
										<mat-icon>add</mat-icon>
										<div class="ml-2">
											{{ t('billing.addCostGroup') }}
										</div>
									</button>
								}
							</div>
						} @else {
							@for (currentCostGroup of costGroups(); track currentCostGroup.exportId; let idx = $index) {
								@if (currentCostGroup?.costGroupTypeExportId === costGroupType.exportId) {
									<vex-cost
										#costGroupItem
										class="pb-4"
										[attr.data-cost-group-type-id]="costGroupType.exportId"
										[allCostsExpanded$]="costsExpandedSubject.asObservable()"
										[inputCostGroup]="currentCostGroup"
										(inputCostGroupChange)="updateCostGroup(idx, $event)"
										[costGroupTypes]="costGroupTypes"
										[costGroupType]="costGroupType"
										[billingId]="billingId()"
										[period]="periodFc.value"
										[previousCostGroups]="previousCostGroups()"
										[previousPeriod]="getPreviousPeriod()"
										[viewMode]="invoiceViewMode()"
										(tabIndexPreserve)="setSelectedTabIndex($event)"
										(navigateToAllocations)="navigateToAllocations.emit()"></vex-cost>
								}
							}
						}
					</mat-tab>
				}
			</mat-tab-group>
		}
	</ng-container>

	<mat-menu #costGroupActions="matMenu">
		<ng-template let-data="matMenuTriggerData" matMenuContent>
			<button (click)="editCostGroupType($event)" mat-menu-item>
				<mat-icon color="primary">edit</mat-icon>
				<div>{{ t('commonActions.edit') }}</div>
			</button>
			<button (click)="deleteCostGroupType($event)" mat-menu-item>
				<mat-icon color="primary">delete</mat-icon>
				<div>{{ t('commonActions.delete') }}</div>
			</button>
		</ng-template>
	</mat-menu>
</div>
